export declare const entity: (entity: Entity, serv: Server, { version }: Options) => void;
export declare const server: (serv: Server) => void;
declare global {
    interface Entity {
        /** Gravity of entity (non-players) to calculate physics. */
        gravity: any;
        /** Decreases velocity when touching blocks */
        friction: any;
    }
}
